<template>
	<main>
		<div v-if="mitra">
		<section  class="vx-row">
			<div class="vx-col w-full md:w-1/2">
				<section class="mb-4">
					<p class="mb-2"><strong>Nama Pimpinan</strong></p>
					<vs-input class="w-full" v-model="mitra.name" />
				</section>
			</div>
			<div class="vx-col w-full md:w-1/2">
				<section class="mb-4">
					<p class="mb-2"><strong>Kategori Sahabat ZX</strong></p>
					<strong class="text-success mb-2">{{ mitra.status_lembaga.name ? mitra.status_lembaga.name : '-' }}</strong>
					<div v-if="mitra.status_lembaga !== null && mitra.status_lembaga.id != 1">
						<strong class="text-warning">{{ mitra.status_upz.name ? mitra.status_upz.name : '-' }}</strong>
					</div>
				</section>
			</div>
			<div class="vx-col w-full md:w-1/2">
				<section class="mb-4">
					<p class="mb-2"><strong>NPWP</strong></p>
					<vs-input class="w-full" v-model="mitra.npwp" />
				</section>
			</div>
			<div class="vx-col w-full md:w-1/2">
				<section class="mb-4">
					<p class="mb-2"><strong>FAX</strong></p>
					<vs-input class="w-full" v-model="mitra.fax" />
				</section>
			</div>
			<div class="vx-col w-full md:w-1/2">
				<section class="mb-4">
					<p class="mb-2"><strong>No. SK</strong></p>
					<vs-input class="w-full" v-model="mitra.no_pengukuhan" />
				</section>
			</div>
			<div class="vx-col w-full md:w-1/2">
				<section class="mb-4">
					<p class="mb-2"><strong>Tanggal SK</strong></p>
					<vs-input type="date" class="w-full" v-model="mitra.tanggal_Pengukuhan" />
				</section>
			</div>
			<div class="vx-col w-full md:w-1/2">
				<section class="mb-4">
					<p class="mb-2"><strong>Website</strong></p>
					<vs-input class="w-full" v-model="mitra.website" />
				</section>
			</div>
			<div class="vx-col w-full md:w-1/2">
				<section class="mb-4">
					<p class="mb-2"><strong>Alamat</strong></p>
					<vs-textarea class="w-full" v-model="mitra.alamat" />
				</section>
			</div>
		</section>
		<vs-divider></vs-divider>
		<section class="vx-row">
			<div class="vx-col w-full md:w-1/2">
				<section class="mb-4">
					<p class="mb-2"><strong>Nama PIC</strong></p>
					<vs-input class="w-full" v-model="mitra.name_person" />
				</section>
			</div>
			<div class="vx-col w-full md:w-1/2">
				<section class="mb-4">
					<p class="mb-2"><strong>Email PIC</strong></p>
					<vs-input class="w-full" v-model="mitra.email_person" />
				</section>
			</div>
			<div class="vx-col w-full md:w-1/2">
				<section class="mb-4">
					<p class="mb-2"><strong>No. Telepon PIC</strong></p>
					<vs-input class="w-full" v-model="mitra.no_telp_person" />
				</section>
			</div>
		</section>
		<vs-divider></vs-divider>
		<div class="vx-row">
			<div class="vx-col w-full mb-6">
				<section class="mb-4">
					<p class="mb-2"><strong>Visi</strong></p>
					<vs-textarea class="w-full" v-model="mitra.visi" />
				</section>
			</div>
			<div class="vx-col w-full mb-6">
				<section class="mb-4">
					<p class="mb-2"><strong>Misi</strong></p>
					<vs-textarea class="w-full" v-model="mitra.misi" />
				</section>
			</div>
		</div>
		<vs-divider></vs-divider>
		<section class="vx-row">
			<div class="vx-col w-full md:w-1/2">
				<section class="mb-4">
					<p ><strong>Dokumen SK Lembaga</strong></p>
					<div class="flex items-center mb-4">
						<feather-icon svgClasses="mr-2" icon="InfoIcon" />
						<p><i>Maksimal ukuran berkas: 1 MB</i></p>
					</div>
					<input type="file" class="hidden" ref="file_sk" @change="setFileSK" />
					<vs-button class="mb-4 rounded-none" size="small" @click.prevent="$refs.file_sk.click()" type="border">
						Pilih Dokumen SK Lembaga
					</vs-button>
					<div class="flex items-center mb-6" v-if="file_sk !== null">
						<strong>{{file_sk_name}}</strong>
						<a href="#" @click.prevent="removeFileSK">
							<feather-icon icon="XIcon" svgClasses="text-danger"></feather-icon>
						</a>
					</div>
					<vx-card v-if="mitra.file_sk !== null" class="bg-grey" style="overflow-x: hidden;">
						<a :href="mitra.file_sk_url" target="_blank">
							<div class="flex items-center">
								<feather-icon icon="FileIcon"></feather-icon>
								<h5 class="ml-4">
									{{ getFileName(mitra.file_sk_name) }}
								</h5>
							</div>
						</a>
					</vx-card>
				</section>
			</div>
			<div class="vx-col w-full md:w-1/2">
				<section class="mb-4">
					<p><strong>Foto Kantor</strong></p>
					<div class="flex items-center mb-4">
						<feather-icon svgClasses="mr-2" icon="InfoIcon" />
						<p><i>Maksimal ukuran berkas: 1 MB</i></p>
					</div>
					<input type="file" class="hidden" ref="file_kantor" @change="setFileKantor" />
					<vs-button class="mb-4 rounded-none" size="small" @click.prevent="$refs.file_kantor.click()" type="border">
						Pilih Foto Kantor
					</vs-button>
					<div class="flex items-center mb-6" v-if="file_kantor !== null">
						<strong>{{file_kantor_name}}</strong>
						<a href="#" @click.prevent="removeFileKantor">
							<feather-icon icon="XIcon" svgClasses="text-danger"></feather-icon>
						</a>
					</div>
					<vx-card v-if="mitra.file_kantor !== null" class="bg-grey" style="overflow-x: hidden;">
						<a :href="mitra.file_kantor_url" target="_blank">
							<div class="flex items-center">
								<feather-icon icon="FileIcon"></feather-icon>
								<h5 class="ml-4">{{ getFileName(mitra.file_kantor_name) }}</h5>
							</div>
						</a>
					</vx-card>
				</section>
			</div>
			<div class="vx-col w-full md:w-1/2">
				<section class="mb-4">
					<p><strong>Dokumen Penunjukan PIC</strong></p>
					<div class="flex items-center mb-4">
						<feather-icon svgClasses="mr-2" icon="InfoIcon" />
						<p><i>Maksimal ukuran berkas: 1 MB</i></p>
					</div>
					<input type="file" class="hidden" ref="file_penunjukan" @change="setFilePenunjukan" />
					<vs-button class="mb-4 rounded-none" size="small" @click.prevent="$refs.file_penunjukan.click()" type="border">
						Pilih Dokumen Penunjukan
					</vs-button>
					<div class="flex items-center mb-6" v-if="file_penunjukan !== null">
						<strong>{{file_penunjukan_name}}</strong>
						<a href="#" @click.prevent="removeFilePenunjukan">
							<feather-icon icon="XIcon" svgClasses="text-danger"></feather-icon>
						</a>
					</div>
					<vx-card v-if="mitra.file_penunjukan !== null" class="bg-grey" style="overflow-x: hidden;">
						<a :href="mitra.file_penunjukan_url" target="_blank">
							<div class="flex items-center">
								<feather-icon icon="FileIcon"></feather-icon>
								<h5 class="ml-4">{{ getFileName(mitra.file_penunjukan_name) }}</h5>
							</div>
						</a>
					</vx-card>
				</section>
			</div>
		</section>
		<vs-divider></vs-divider>
		<vs-button id="btn-submit" @click.prevent="submit">
			SUBMIT
		</vs-button>
		</div>
	</main>
</template>
<script>
	import {mapState} from 'vuex'

	const maxFileSize = 1000000;
	export default {
		data: () => ({
			user: null,
			params: {},
			mitra: null,
			file_sk: null,
			file_sk_name: null,
			file_kantor: null,
			file_kantor_name: null,
			file_penunjukan: null,
			file_penunjukan_name: null
		}),
		computed: {
			...mapState('auth', ['profile'])
		},
		methods: {
			getFileName(path) {
				if(path.split('/').length > 1) {
					return path.split('/')[path.split('/').length - 1]
				}
				
				return path
			},
			submit() {

				this.mitra.user_id = this.mitra.user.id

				// Set payload for file
				const payloadFile = {}
				if(this.file_sk !== null) {
					payloadFile.file_sk = this.file_sk
				}

				if(this.file_kantor !== null) {
					payloadFile.file_kantor = this.file_kantor
				}

				if(this.file_penunjukan !== null) {
					payloadFile.file_penunjukan = this.file_penunjukan	
				}

				if(this.mitra.tanggal_Pengukuhan !== null) {
					this.mitra.tanggal_Pengukuhan = this.mitra.tanggal_Pengukuhan.split('-').reverse().join('/')
				}

				if(this.mitra.status_lembaga !== null) {
					this.mitra.status_lembaga = this.mitra.status_lembaga.id
				}
				if(this.mitra.status_upz !== null) {
					this.mitra.status_upz = this.mitra.status_upz.id
				}

				// update just mitra
				if( Object.keys(payloadFile) < 1 ) {
					this.$vs.loading({
						container: '#btn-submit',
						scale: 0.5
					})
					
					this.$store.dispatch('mitra/save', [this.mitra])
					.then(() => {
						this.file_sk = null
						this.file_sk_name = null

						this.file_kantor = null
						this.file_kantor_name = null

						this.file_penunjukan = null
						this.file_penunjukan_name = null
						this.$vs.loading.close('#btn-submit > .con-vs-loading')
						this.$vs.notify({
							title: 'Profil Anda Berhasil Diupdate',
							text: '',
							color: 'success',
							position: 'top-right'
						})
						this.$router.push('/profile/success')
					})
					.catch(e => {
						this.$vs.loading.close('#btn-submit > .con-vs-loading')
						if(e.response) {
							console.error(e.response)
						}

						return false
					})
				}
				else { //
					// Upload MassFIle

					this.$vs.loading({
						container: '#btn-submit',
						scale: 0.5
					})

					this.$store.dispatch('uploadFileMitra', payloadFile)
					.then(files => {
						
						Object.keys(payloadFile).forEach((prop, i) => {
							this.mitra[prop] = files[i].link
						})

						this.$store.dispatch('mitra/save', [this.mitra])
						.then(() => {
							this.file_sk = null
							this.file_sk_name = null

							this.file_kantor = null
							this.file_kantor_name = null

							this.file_penunjukan = null
							this.file_penunjukan_name = null
							this.$vs.loading.close('#btn-submit > .con-vs-loading')
							this.$vs.notify({
								title: 'Profil Anda Berhasil Diupdate',
								text: '',
								color: 'success',
								position: 'top-right'
							})
							
							this.$router.push('/profile/success')
						})
						.catch(e => {
							this.$vs.loading.close('#btn-submit > .con-vs-loading')
							if(e.response) {
								console.error(e.response)
							}

							return false
						})
					})
					.catch(e => {
						this.$vs.loading.close('#btn-submit > .con-vs-loading')
						if(e.response) {
							console.error(e.response)
						}

						return false
					})
				}
			},
			removeFilePenunjukan() {
				this.$refs.file_penunjukan.value = null
				this.file_penunjukan = null
				this.file_penunjukan_name = null
			},
			removeFileSK() {
				this.$refs.file_sk.value = null
				this.file_sk = null
				this.file_sk_name = null
			},
			removeFileKantor() {
				this.$refs.file_kantor.value = null
				this.file_kantor = null
				this.file_kantor_name = null
			},
			setFileKantor() {
				const file = this.$refs.file_kantor.files[0],
					arrFile = file.name.split('.'),
					ext = arrFile[arrFile.length - 1].toLowerCase()
				
				if( !['jpg', 'jpeg', 'png', 'gif', 'docx', 'doc', 'pdf'].includes(ext) ) {
					this.$vs.notify({
						title: 'Peringatan',
						text: 'Harap masukan dokumen atau gambar',
						color: 'warning',
						position: 'top-right'
					})

					this.file_kantor = null
					this.file_kantor_name = null

					return false
				}

				// File Size Validation
				if( file.size > maxFileSize ) {
					this.$vs.notify({
						title: 'Peringatan',
						text: 'Maksimal Ukuran 1 MB',
						color: 'warning',
						position: 'top-right'
					})

					this.file_kantor = null
					this.file_kantor_name = null

					return false
				}

				this.file_kantor = file
				this.file_kantor_name = file.name
			},
			setFileSK() {
				const file = this.$refs.file_sk.files[0],
					arrFile = file.name.split('.'),
					ext = arrFile[arrFile.length - 1].toLowerCase()
				
				if( !['jpg', 'jpeg', 'png', 'gif', 'docx', 'doc', 'pdf'].includes(ext) ) {
					this.$vs.notify({
						title: 'Peringatan',
						text: 'Harap masukan dokumen atau gambar',
						color: 'warning',
						position: 'top-right'
					})

					this.file_sk = null
					this.file_sk_name = null

					return false
				}

				// File Size Validation
				if( file.size > maxFileSize ) {
					this.$vs.notify({
						title: 'Peringatan',
						text: 'Maksimal Ukuran 1 MB',
						color: 'warning',
						position: 'top-right'
					})

					this.file_sk = null
					this.file_sk_name = null

					return false
				}

				this.file_sk = file
				this.file_sk_name = file.name
			},
			setFilePenunjukan() {
				const file = this.$refs.file_penunjukan.files[0],
					arrFile = file.name.split('.'),
					ext = arrFile[arrFile.length - 1].toLowerCase()
				
				if( !['jpg', 'jpeg', 'png', 'gif', 'docx', 'doc', 'pdf'].includes(ext) ) {
					this.$vs.notify({
						title: 'Peringatan',
						text: 'Harap masukan dokumen atau gambar',
						color: 'warning',
						position: 'top-right'
					})

					this.file_penunjukan = null
					this.file_penunjukan_name = null

					return false
				}

				// File Size Validation
				if( file.size > maxFileSize ) {
					this.$vs.notify({
						title: 'Peringatan',
						text: 'Maksimal Ukuran 1 MB',
						color: 'warning',
						position: 'top-right'
					})

					this.file_penunjukan = null
					this.file_penunjukan_name = null

					return false
				}

				this.file_penunjukan = file
				this.file_penunjukan_name = file.name
			},
			getDataMitra() {
				this.$vs.loading()
				this.$store.dispatch('mitra/getData', this.params)
				.then(mitra => {
					this.$vs.loading.close()
					this.mitra = mitra[0]
					this.mitra.file_kantor_name = null
					this.mitra.file_penunjukan_name = null
					this.mitra.file_sk_name = null
					if(this.mitra.file_kantor !== null) {
						this.mitra.file_kantor_name = this.mitra.file_kantor
						this.mitra.file_kantor_url = process.env.VUE_APP_STORAGE + '/' + this.mitra.file_kantor
					}

					if(this.mitra.file_sk !== null) {
						this.mitra.file_sk_name = this.mitra.file_sk
						this.mitra.file_sk_url = process.env.VUE_APP_STORAGE + '/' + this.mitra.file_sk
					}

					if(this.mitra.file_penunjukan !== null) {
						this.mitra.file_penunjukan_name = this.mitra.file_penunjukan
						this.mitra.file_penunjukan_url = process.env.VUE_APP_STORAGE + '/' + this.mitra.file_penunjukan
					}

					if(this.mitra.tanggal_Pengukuhan !== null) {
						this.mitra.tanggal_Pengukuhan = this.mitra.tanggal_Pengukuhan.split('/').reverse().join('-')
					}
				})
				.catch(e => {
					this.$vs.loading.close()
					if(e.response) {
						console.error(e.response)
						this.$vs.notify({
							title: 'Oops',
							text: e.response.data.message,
							color: 'warning',
							position: 'top-right'
						})
					}

					return false
				})
			}
		},
		created() {
			this.user = {}
			Object.assign(this.user, this.profile)
			this.params = {
				user_id: this.user.id
			}

			this.getDataMitra()

		}
	}
</script>